<template>
  <div class="content">
    <TopVedio/>
    <!-- <LazyLoading > -->
      <SmartDoor/>
    <!-- </LazyLoading> -->
    <!-- <LazyLoading :dis="100" > -->
      <MeetingRoom/>
    <!-- </LazyLoading> -->
    <!-- <LazyLoading  :dis="100"  >  -->
      <Content/>
   <!-- </LazyLoading> -->
    <NovoGotop/>
    <NovoFooter/>
  </div>
</template>

<script>
import TopVedio from "./top-vedio";
import SmartDoor from "./smart-door";
import MeetingRoom from "./meeting-room";
import Content from "./content";
import { NovoFooter, NovoGotop, LazyLoading } from "novo-ui";

export default {
  name: "Home",
  components: {
    TopVedio,
    SmartDoor,
    MeetingRoom,
    Content,
    NovoFooter,
    NovoGotop,
    LazyLoading
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~common/scss/variable";
@import "~common/scss/mixin";
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue